import * as Yup from 'yup';
import {
  invalidEmailFormat,
  passwordNotMatch,
  passwordRuleSet,
  requiredField,
} from './utils/messages';

export const loginValidationSchema = Yup.object().shape({
  userName: Yup.string().required(requiredField),
  password: Yup.string().required(requiredField),
});

export const forgetPasswordValidationSchema = Yup.object().shape({
  user_recover: Yup.string().email(invalidEmailFormat).required(requiredField),
});

const regexPassword = /^(?=.*?[A-Z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/;

export const newPasswordValidationSchema = Yup.object().shape({
  password: Yup.string().matches(regexPassword, passwordRuleSet).required(requiredField),
  password_confirm: Yup.string()
    .oneOf([Yup.ref('password'), null], passwordNotMatch)
    .required(requiredField),
});
